import uni from "../styles/univesal.module.css";
import { header } from "./common";
import { LangIds, Languages, getLang } from "../langs/langs";

interface Props {
  lang: Languages;
  headerText: String;
  headerNum: String;
  msgTop: string;
  msgBottom: string;
  onRetake: () => void;
}

function ErrorMsg({lang, headerText, headerNum, msgTop, msgBottom, onRetake}: Props) {
  return (
    <>
    <div className={uni.container}>
      {header(headerText, headerNum)}
      <div className={uni.innerSmallCenterContainer}>
        <div className={uni.spacerBig}/>
        <svg className={uni.center}
          width="44"
          height="43"
          viewBox="0 0 44 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          >
          <path className={uni.errorIconPath}
            d="M43.1814 0.804671C42.1085 -0.268224 40.371 -0.268224 39.2981 0.804671L22.4861 17.6167L5.67405 0.804671C4.60115 -0.268224 2.86365 -0.268224 1.79075 0.804671C0.71786 1.87665 0.71786 3.61598 1.79075 4.68796L18.6028 21.5L1.79075 38.312C0.71786 39.384 0.71786 41.1234 1.79075 42.1953C2.3272 42.7318 3.03026 43 3.7324 43C4.43454 43 5.1376 42.7318 5.67405 42.1953L22.4861 25.3833L39.2981 42.1953C39.8346 42.7318 40.5376 43 41.2398 43C41.9419 43 42.645 42.7318 43.1814 42.1953C44.2543 41.1234 44.2543 39.384 43.1814 38.312L26.3694 21.5L43.1814 4.68796C44.2543 3.61598 44.2543 1.87573 43.1814 0.804671Z"
            fill="#B00020"
          />
        </svg>
        <div className={uni.spacerBig}/>
        <div className={uni.bigText}>{msgTop}</div>
        <div className={uni.spacer}/>
        <div className={uni.mediumText}>{msgBottom}</div>
        <div className={uni.spacerBig}/>
        <button className={uni.blankButton} type="button" onClick={onRetake}>{getLang(LangIds.ERROR_Retake, lang)}</button>
        <div className={uni.spacer}/>
      </div>
    </div>
    </>
  );
}

export default ErrorMsg;
